import { Command } from "commander";

import { assetsCmd } from "@/src/commands/assets/index.ts";
import { stylesCmd } from "@/src/commands/styles/index.ts";
import { variablesCmd } from "@/src/commands/variables/index.ts";
import { logger } from "@/src/utils/logger.ts";
import { globalOptions } from "@/src/utils/options.ts";

export const generateCmd = new Command()
  .name("generate")
  .alias("gen")
  .description(
    "run `variables`, `styles`, and `assets` commands in this specific order",
  )
  .action(async (_, command) => {
    const optsWithGlobals = command.optsWithGlobals();
    logger.setDebugModeTo(optsWithGlobals.debug);

    logger.debug(
      "Mapping global options to each command called by the generate command.",
    );

    // Add global options
    globalOptions.forEach((o) => {
      assetsCmd.addOption(o);
      stylesCmd.addOption(o);
      variablesCmd.addOption(o);
    });

    logger.debug("Starting assets command.");
    await assetsCmd.parseAsync([]);

    logger.debug("Starting styles command.");
    await stylesCmd.parseAsync([]);

    logger.debug("Starting variables command.");
    await variablesCmd.parseAsync([]);
  });
